// extracted by mini-css-extract-plugin
module.exports = {"b4jyj9b":"b4jyj9b"};